import { FacetRepository, FacetService } from '@aipb/gulliver/catalog/data-access';
import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import {
  FacetConfigItem,
  FacetConfigTimeline,
  FacetConfigTimelineSettings,
  FacetConfigTree,
  FacetConfigTreeSettings,
  SearchItem
} from '@aipb/gulliver/catalog/model';
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Observable } from 'rxjs';
import { MtxButtonModule } from '@ng-matero/extensions/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';
import { FacetTreeComponent } from '../facet-tree/facet-tree.component';
import { FacetTimelineComponent } from '../facet-timeline/facet-timeline.component';
import { FacetMapComponent } from '../facet-map/facet-map.component';
import { FacetListComponent } from '../facet-list/facet-list.component';
import { filter, mergeMap } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FieldRepository } from '@aipb/gulliver/castor/data-access';
import { FacetStatisticsComponent } from '../facet-statistics/facet-statistics.component';

@UntilDestroy()
@Component({
  selector: 'cat-facet-container',
  templateUrl: './facet-container.component.html',
  styleUrls: ['./facet-container.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MtxButtonModule,
    MatIconModule,
    MatTabsModule,
    TranslocoModule,
    FacetTreeComponent,
    FacetTimelineComponent,
    FacetMapComponent,
    FacetListComponent,
    FacetStatisticsComponent
  ]
})
export class FacetContainerComponent implements OnInit {
  @Input() searchItem: SearchItem;

  private catalogEnv = inject(CatalogEnvService);
  facetConfigurations: FacetConfigItem[] = this.catalogEnv.env.facetConfigurations;
  private facetRepository = inject(FacetRepository);
  selectedTabIndex$ = this.facetRepository.selectedTabIndex$;
  loading$: Observable<boolean> = this.facetRepository.loading$;
  private fieldRepository = inject(FieldRepository);
  private facetService = inject(FacetService);

  ngOnInit() {
    this.fieldRepository
      .selectRegister(this.searchItem.coreId)
      .pipe(
        filter((r) => r.length > 0),
        mergeMap(() => this.facetService.loadFacets(this.searchItem)),
        untilDestroyed(this)
      )
      .subscribe();
  }

  setSelectedTabIndex(selectedTabIndex: number) {
    this.facetRepository.setSelectedTabIndex(selectedTabIndex);
  }

  getTreeSettings(item: FacetConfigItem): FacetConfigTreeSettings {
    return (<FacetConfigTree>item).settings;
  }

  getTimelineSettings(item: FacetConfigItem): FacetConfigTimelineSettings {
    return (<FacetConfigTimeline>item).settings;
  }

  selectFacetItem() {
    return this.facetRepository.selectEntity(this.searchItem.id);
  }
}
